export const userState = {
  test: 'data from pinia userState',
  loggedin: false,
  displayname: '',
  userid: '',
  email: '',
  affilitation: 'KardeMEMAS',
  primaryuser: {},
  activeprimaryuser: {},
  secondaryuser: {},
  notregistered: true,
  primaryselected: false,
  engageuser: {},
  adminUsers: [] // List of other users that can do admin Stuff...
}
